import { create } from 'zustand';
import { storeService } from '../services/storeService';
import { PaymentSettings } from '../models';

interface PaymentSettingsStore {
  settings: PaymentSettings | null;
  loading: boolean;
  loaded: boolean;
  error: Error | null;
  fetchPromise: Promise<void> | null;
  loadPaymentSettings: () => Promise<void>;
}

export const usePaymentSettingsStore = create<PaymentSettingsStore>((set, get) => ({
  settings: null,
  loading: false,
  loaded: false,
  error: null,
  fetchPromise: null,

  loadPaymentSettings: () => {
    const { loaded, fetchPromise } = get();

    if (loaded || fetchPromise) {
      return fetchPromise ?? Promise.resolve();
    }

    const promise = (async () => {
      set({ loading: true, error: null });
      try {
        const data = await storeService.getPaymentSettings();
        set({ settings: data, loaded: true, loading: false });
      } catch (err) {
        set({
          error: err instanceof Error ? err : new Error('Erro ao carregar condições de pagamento'),
          loading: false,
        });
      } finally {
        set({ fetchPromise: null });
      }
    })();

    set({ fetchPromise: promise });
    return promise;
  },
}));
